import axios from "axios"
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface HttpClientConfig {
  baseURL: string
  headers?: Record<string, string>
  timeout?: number
}

export class HttpClient {
  protected readonly client: AxiosInstance

  constructor(config: HttpClientConfig) {
    this.client = axios.create({
      baseURL: config.baseURL,
      timeout: config.timeout ?? 30_000,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
    })
  }

  protected async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const res: AxiosResponse<T> = await this.client.post(url, data, config)
    return res.data
  }

  protected async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const res: AxiosResponse<T> = await this.client.get(url, config)
    return res.data
  }

  /** Fetch a plain-text response (e.g. Cloudflare trace `key=value` payloads). */
  protected async getText(url: string, config?: AxiosRequestConfig): Promise<string> {
    const res = await this.client.get<string>(url, { ...config, responseType: "text" })
    return res.data
  }
}
